import React, { useEffect } from 'react';
import List from './list';
import classNames from 'classnames';
import TitleTotal from './title-total';
import None from './none';

import ExpressStore from '@/stores/express';
import PageStore from '@/stores/page';
import ResetStore from './Reset-Store';
import SkuStore from '@/stores/sku';
import MyLazyComponent from '@/common/lazy-load';

import './index.less';

interface AvailableActivity {
  activityId: number;
  endTime: number;
  hasLimit: boolean;
  limitCount: number;
  promotionContent: string;
  startTime: number;
  status: string;
}
interface PropType {
  skuAttrs: SkuTypes.SkuAttr[];
  price: PriceTypes.Root;
  i18n: { [key: string]: string };
  inventory: InventoryTypes.Root;
  skuInfoMap: InventoryTypes.SkuInfoMap;
  // 区分页面和弹窗不同组件入口
  moduleName: string;
  sampleInfo: SampleTypes.Root;
  type: SkuTypes.TypeInfo;
  moq: number;
  renderConfig: DetailTypes.renderConfig<{
    showType: string;
  }>;
  visitCountry: string;
  productId: number;
  hasLogistics: boolean;
  productIsMarketGoods: boolean;
  sourcingTradeAvailable: boolean;
  isDispatchGuaranteed: boolean;
  pcSemiSwitch: boolean;
  coreCountry: boolean;
  abtest: DetailTypes.Abtest;
  aliId: number;
  semiLightCustomization: boolean;
  availableActivity: AvailableActivity;
}

export default function Index(props: PropType) {
  const {
    skuAttrs = [],
    inventory,
    type = 'product',
    renderConfig,
    moduleName,
    hasLogistics,
    i18n,
  } = props;

  const { showType } = renderConfig;
  const expressStore = ExpressStore((state) => state);
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  //如果无库存信息不展示sku-info楼层
  const { preferedDispatchId, defaultDispatchId } = inventory;
  const skuStore = SkuStore((state) => state);

  const skuInfo = skuStore[type];
  // 获取更新发货地
  const dispatchId = expressStore.dispatchId || preferedDispatchId || defaultDispatchId;
  useEffect(() => {
    // 设置发货地
    expressStore.setDispatchById(dispatchId);
  }, []);

  const defaultLogistic = () => {
    return (
      <div className="sku-logistic">
        <div className="logistic-item">
          <h4>{i18n['202107_detail_pc_ShippingFloor_ShippingTitle']}</h4>
          {!hasLogistics && (
            <span
              dangerouslySetInnerHTML={{
                __html: i18n['detail_pc_shipping_no_result'].replace(
                  '{0}',
                  `<a href="#">${i18n['navigation.contact_contact']}</a>`,
                ),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const Logistic = MyLazyComponent(
    /* webpackChunkName: "logistic" */
    () => import('@/component/module_actions/logistic'),
    defaultLogistic(),
  );
  if (!inventory) return null;
  // 库存数据
  const skuInventoryMap = inventory.repoSkuInventory[dispatchId].skuMap;
  // 初始化,attr是调整好顺序的sku数据集合
  const { attr = [] } = skuInfo;

  const renderLogistic = () => {
    if (moduleName === 'module_quick_right') return null;
    return isLoaded ? <Logistic {...props} type={type} /> : defaultLogistic();
  };

  //无sku情况
  if (skuAttrs.length === 0) {
    return (
      <>
        <ResetStore {...props} skuInventoryMap={skuInventoryMap} dispatchId={dispatchId} />
        <None showType={showType} {...props}>
          <>{renderLogistic()}</>
        </None>
      </>
    );
  }

  return (
    <div
      className={classNames({
        'sku-layout': true,
        logistics: hasLogistics,
      })}
      key={type}
    >
      <ResetStore {...props} skuInventoryMap={skuInventoryMap} dispatchId={dispatchId} />
      {/* 外面的sku面板 */}
      {showType !== 'drawer' && (
        <TitleTotal showType={showType} type={type} skuAttrs={skuAttrs} i18n={i18n} attr={attr} />
      )}
      {/* 按项展示具体的sku内容 */}
      <div
        className="sku-info"
        style={{
          minHeight: skuAttrs.length > 3 ? '270px' : `${skuAttrs.length * 91}px`,
        }}
      >
        {attr.map((i, index) => (
          <List {...props} index={index} key={index} data={i} skuAttr={attr} type={type} />
        ))}
      </div>

      {renderLogistic()}
    </div>
  );
}
